import { getAutomationsRouteContext } from '@/lib/automations/automationRoutes.js';
/* Selector file rule: root-level functions in this file must be exported selectors only. Move helper functions to lib files. */
import { createSelector } from 'reselect';
import normalizePathname from '@/lib/routes/normalizePathname.js';
import { threadMetaById } from '@/redux/selectors/pieveSelectors/baseSelectors.js';
import extractRouteThreadId from '@/redux/selectors/pieveSelectors/lib/extractRouteThreadId.js';
import getThreadType from '@/redux/selectors/pieveSelectors/lib/getThreadType.js';
import { isDraftThreadActive } from '@/redux/selectors/pieveSelectors/sidebarProjectSelectors.js';
import { mainThreadHydrationSettled as selectMainThreadHydrationSettled, pathname as selectedPathname, pendingSkillDraftItem as selectedPendingSkillDraftItem } from '@/redux/selectors/uiSelectors.js';

export const routeThreadId = createSelector([selectedPathname], (pathname) => {
  return extractRouteThreadId({
    pathname
  });
});

export const normalizedPathname = createSelector([selectedPathname], (pathname) => {
  return normalizePathname(pathname);
});

export const routeThreadType = createSelector([routeThreadId, threadMetaById], (threadId, threadMetaByIdValue) => {
  if (!threadId) {
    return '';
  }

  return getThreadType(threadMetaByIdValue?.[threadId] || null);
});

export const isAutomationsWorkspaceRoute = createSelector([normalizedPathname], (pathname) => {
  return getAutomationsRouteContext(pathname).isAutomationsView;
});

export const isThreadScreenView = createSelector([isAutomationsWorkspaceRoute], (isAutomationsWorkspaceRouteValue) => {
  return !isAutomationsWorkspaceRouteValue;
});

export const isPersistedThreadRoute = createSelector([isThreadScreenView, routeThreadId, isDraftThreadActive], (isThreadScreenViewValue, selectedRouteThreadId, isDraftThreadActiveValue) => {
  return Boolean(isThreadScreenViewValue && selectedRouteThreadId && !isDraftThreadActiveValue);
});

export const shouldSuppressMainThreadEmptyState = createSelector([isThreadScreenView, isDraftThreadActive, selectedPendingSkillDraftItem, selectMainThreadHydrationSettled, isPersistedThreadRoute, isAutomationsWorkspaceRoute], (isThreadScreenViewValue, isDraftThreadActiveValue, pendingSkillDraftItem, isMainThreadHydrationSettled, isPersistedThreadRouteValue, isAutomationsWorkspaceRouteValue) => {
  return Boolean(isThreadScreenViewValue && !isDraftThreadActiveValue && !pendingSkillDraftItem?.id && (!isMainThreadHydrationSettled || isPersistedThreadRouteValue) && !isAutomationsWorkspaceRouteValue);
});
